export const USERS = {
    login: "login",
    createUser: "createUsuarioSupervisor"
};

export const FORM = {
    form: "createForm",
    getForms: "forms"
}
